/// <amd-module name="SuiteCommerce.CookieConsent.Common.Configuration"/>
define("SuiteCommerce.CookieConsent.Common.Configuration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Configuration = void 0;
    var environment = null;
    var OverlayColor;
    (function (OverlayColor) {
        OverlayColor["DARK"] = "dark";
        OverlayColor["LIGHT"] = "light";
    })(OverlayColor || (OverlayColor = {}));
    var Configuration = /** @class */ (function () {
        function Configuration() {
        }
        Object.defineProperty(Configuration, "environment", {
            set: function (environmentComponent) {
                environment = environmentComponent;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "cookieSettingsShortText", {
            get: function () {
                return this.get('cookieConsent.cookieSettingsShortText') || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "strictlyNecessaryCookiesText", {
            get: function () {
                return this.get('cookieConsent.strictlyNecessaryCookiesText') || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "analyticsCookiesText", {
            get: function () {
                return this.get('cookieConsent.analyticsCookiesText') || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "bannerText", {
            get: function () {
                var bannerText = this.get('cookieConsent.cookieBannerText') || '';
                return this.bannerTextUrlHelper(bannerText, this.cookiePolicyPageLink);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "cookiePolicyPageLink", {
            get: function () {
                return this.get('cookieConsent.urlCookiePolicyPage') || '';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "areAllRequiredFieldsFulfilled", {
            get: function () {
                return (!!this.cookieSettingsShortText &&
                    !!this.strictlyNecessaryCookiesText &&
                    !!this.analyticsCookiesText &&
                    !!this.bannerText);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "overlayColor", {
            get: function () {
                var overlayOption = this.get('cookieConsent.cookieBannerOverlay');
                return OverlayColor[overlayOption] || 'dark';
            },
            enumerable: false,
            configurable: true
        });
        Configuration.get = function (key) {
            if (environment) {
                return environment.getConfig(key);
            }
            console.error('Please set the Environment Component in the Configuration.');
            return null;
        };
        Configuration.bannerTextUrlHelper = function (bannerText, cookiePolicyPageLink) {
            if (bannerText && cookiePolicyPageLink) {
                return bannerText.indexOf('[[cookiepolicypage]]') !== -1
                    ? bannerText.replace('[[cookiepolicypage]]', " <a target='_blank' aria-label='View Cookie Policy Page' href='" + cookiePolicyPageLink + "'>Cookie Policy page</a> ")
                    : bannerText;
            }
            return bannerText;
        };
        return Configuration;
    }());
    exports.Configuration = Configuration;
});
